/* eslint-disable react-hooks/exhaustive-deps */

import { withStyles } from '@material-ui/core';
import { Box, Grid } from '@mui/material';

import { compose } from 'recompose';
import { connect } from 'react-redux';
import FullscreenSpinner from 'modules/common/fullscreenSpinner.component';
import { Permissions } from 'modules/layout/permissions';
import { hasPermission } from 'modules/layout/permissionService';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import {
  getAuthClientPolicies,
  getAuthDateSummary,
  getAuthorizationSummary,
  getCommunicationInfo,
  getDepartureAddress,
  getDestinationAddress,
  getEmployeeInfo,
  getFamilyMembers,
  getFamilyPets,
  getServices,
  getTeam,
  getUserSettings,
  setAuthId,
  setLoadingComplete,
  getAddress,
  getAuthTripsByAuthId,
  getAuthorizationAreaTour
} from '../../store/actions/authorizations.actions';
import { getBrokerAgents, getVendors } from 'modules/authorizations/store/actions/dataManagement.actions';
import {
  getCandidateServices,
  getCandidateTrips,
  getCostEstimates,
  getTravelBookingRequestsByAuth
} from 'modules/authorizations/store/actions/canidateTrip.actions';

import { COLOR_PRIMARY, COLOR_SECONDARY, COLOR_WARNING } from 'styles/theme';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import CandidateServices from './candidateServices.component';
import {
  fetchAuthCanidateDetails,
  fetchAuthDetails,
  fetchBrokerAgents,
  fetchEnumerations,
  fetchVendors
} from 'modules/authorizations/utils/fetchDataDetailsService';
import { showToast } from 'modules/layout/layout.actions';
import {
  getAllCountries,
  getAllCurrencies,
  getAllEnumerations,
  getAllProvinces,
  getAllSaleTypes,
  getAllWeightTypes
} from 'modules/enumerations/store/enumerationActions';
import { getEmailTemplateSummaries } from 'modules/emailTemplates/store/emailTemplate.actions';
import { getClientDetails, setClientId } from 'modules/clients/clients.actions';

const styles = theme => ({
  card: {
    width: '100%',
    maxWidth: 1500,
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  }
});
const SHORT_TERM_ASSIGNMENT_MOVE_TYPE_ID = '83BBE794-E171-403E-B545-23508B017354';

const CandidateServicesView = props => {
  const theme = createTheme({
    palette: {
      primary: COLOR_PRIMARY,
      secondary: COLOR_SECONDARY,
      warning: COLOR_WARNING
    }
  });

  const details = props.authorizationDetails ? props.authorizationDetails[props.match.params.id] : null;
  const moveType = details?.authorizationDetails?.moveTypeId;

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      const id = props.match.params.id;
      props.setAuthId(id);

      await fetchAuthDetails(details, id, props);
      await fetchVendors(props?.vendors, props);
      await fetchBrokerAgents(props?.brokerAgents, props);
      await fetchAuthCanidateDetails(details, id, props);
      await fetchEnumerations(props);
      if (!props.templates || props.templates.isLoaded === false) {
        await props.getEmailTemplateSummaries();
      }
      props.setLoadingComplete();
      setIsLoading(false);
    }
    fetchData();
  }, details);

  const isValidMoveType = () => {
    if (moveType === '4dc01913-217d-44bd-8e4e-82c8b82f6de4' || moveType === '0b776b0c-6610-41b5-a312-2a3b43c82679') return true;
    return false;
  };
  const canReadCandidateServices = hasPermission(Permissions.File.CandidateIntern.Read);
  const canEditCandidateServices = hasPermission(Permissions.File.CandidateIntern.Edit);
  const isShortTermAssignment = moveType.toUpperCase() === SHORT_TERM_ASSIGNMENT_MOVE_TYPE_ID;
  const staEditAccess = hasPermission(Permissions.File.STA.Edit);

  if (!canReadCandidateServices) {
    props.history.push('/');
    return null;
  }

  return (
    <ThemeProvider theme={theme}>
      <Box>
        {!isLoading && details && (
          <>
            {isValidMoveType() ? (
              <Grid>
                <CandidateServices
                  details={details}
                  authId={props.match.params.id}
                  brokerAgents={props.brokerAgents || []}
                  history={props.history}
                  location={props.location}
                  enumerations={props.enumerations}
                  emailTemplates={props.templates ? props.templates.emailTemplates : []}
                  vendors={props.vendors}
                  clientInfo={props.clientsInfo[details.authorizationDetails.clientId]}
                  isReadOnly={isShortTermAssignment ? !staEditAccess : !canEditCandidateServices}
                />
              </Grid>
            ) : (
              <Box display="flex" justifyContent="center" mb={2}>
                <h5 style={{ color: 'red', fontSize: '24px', fontWeight: 'bold', textAlign: 'center' }}>
                  If this is a candidate file, please change the move type accordingly.
                </h5>
              </Box>
            )}
          </>
        )}
        {isLoading && <FullscreenSpinner />}
      </Box>
    </ThemeProvider>
  );
};

CandidateServicesView.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  const { authorizationDetails, brokerAgents, isLoading, vendors, currentAuthId } = state.authorizations;
  const { unmappedClients, clientsInfo } = state.clients;
  const enumerations = state.enumerations;
  const { agents } = state.common;
  const templates = state.templates;
  return {
    authorizationDetails,
    brokerAgents,
    unmappedClients,
    isLoading,
    vendors,
    enumerations,
    currentAuthId,
    templates,
    agents,
    clientsInfo
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    getAuthorizationSummary,
    getEmployeeInfo,
    getCommunicationInfo,
    getAuthClientPolicies,
    setAuthId,
    setLoadingComplete,
    getAuthDateSummary,
    getDepartureAddress,
    getDestinationAddress,
    getTeam,
    getServices,
    getUserSettings,
    getBrokerAgents,
    getCandidateServices,
    getCandidateTrips,
    getTravelBookingRequestsByAuth,
    getCostEstimates,
    showToast,
    getVendors,
    getFamilyMembers,
    getAddress,
    getFamilyPets,
    getAuthTripsByAuthId,
    getAllEnumerations,
    getAllSaleTypes,
    getAllWeightTypes,
    getAllProvinces,
    getAllCurrencies,
    getAllCountries,
    getAuthorizationAreaTour,
    getEmailTemplateSummaries,
    getClientDetails,
    setClientId
  })
)(CandidateServicesView);
